import lodash from 'lodash'
import { useMemo } from 'react'

import { useField } from '../../../../../1stlog-ui/src/components/Field'
import { TOrderEntryProvider } from '../../types'
import useOrderEntry from '../../useOrderEntry'
import basicProvider from './ProviderSelect/basicProvider'

const useProvider = (): TOrderEntryProvider | undefined => {
  const { providers } = useOrderEntry()

  const providerId = useField('provider')

  const allProviders: TOrderEntryProvider[] = useMemo(() => {
    return lodash.concat(providers, [basicProvider])
  }, [providers, basicProvider])

  return lodash.find(allProviders, (p) => p.id === providerId)
}

export default useProvider
